import { render, staticRenderFns } from "./five-star-rating.vue?vue&type=template&id=fb699226"
import script from "./five-star-rating.vue?vue&type=script&lang=js"
export * from "./five-star-rating.vue?vue&type=script&lang=js"
import style0 from "./five-star-rating.vue?vue&type=style&index=0&id=fb699226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports